var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-10" },
    [
      _c(
        "md-card",
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c("md-button", { staticClass: "expand-button-size" }, [
                        _c(
                          "strong",
                          {
                            on: {
                              click: function($event) {
                                return _vm.expandActivityLog()
                              }
                            }
                          },
                          [
                            _vm._v("Activity\n              "),
                            _c("span", [
                              _vm._v(
                                "(" + _vm._s(_vm.ask.activityLogLength) + ")"
                              )
                            ])
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _c("md-card-content", { staticClass: "comments" }, [
                    _c(
                      "div",
                      { staticClass: "activity-log" },
                      _vm._l(_vm.sortActivities, function(activity, index) {
                        return _c(
                          "div",
                          {
                            key: activity.action + index,
                            staticClass: "activity"
                          },
                          [
                            !activity.recipient_email
                              ? _c("div", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("momentDateUTC")(activity.when)
                                      ) + " "
                                    ),
                                    activity.memberName
                                      ? _c("span", [
                                          _vm._v(
                                            "- " + _vm._s(activity.memberName)
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  activity.action === "Tagged"
                                    ? _c(
                                        "p",
                                        { staticClass: "ask-description" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              activity.description.replace(
                                                /,/g,
                                                ", "
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : activity.description.match(
                                        /Responded with/
                                      )
                                    ? _c("p", {
                                        staticClass: "ask-description",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            activity.description
                                          )
                                        }
                                      })
                                    : _c(
                                        "p",
                                        { staticClass: "ask-description" },
                                        [_vm._v(_vm._s(activity.description))]
                                      ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "ask-description" }, [
                                    _vm._v(_vm._s(activity.details))
                                  ])
                                ])
                              : _c(
                                  "div",
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("momentDateUTC")(activity.when)
                                        ) +
                                        ":\n                " +
                                        _vm._s(activity.memberName) +
                                        "\n                "
                                    ),
                                    _c("b", [_vm._v(_vm._s(activity.action))]),
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(activity.details) +
                                        "\n                "
                                    ),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "Action: " +
                                          _vm._s(activity.action_taken)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("span", [_vm._v("Action Taken: ")]),
                                    _vm._v(" "),
                                    _c(
                                      "md-chip",
                                      {
                                        staticClass: "action-event",
                                        style: {
                                          backgroundColor: [
                                            activity.action_type == "yes"
                                              ? "lightgreen"
                                              : "#FC9A9A"
                                          ]
                                        }
                                      },
                                      [_vm._v(_vm._s(activity.action_type))]
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v("Sent To "),
                                    _vm._l(activity.recipient_email, function(
                                      email,
                                      index
                                    ) {
                                      return _c(
                                        "span",
                                        { key: activity.action + index },
                                        [_vm._v(_vm._s(email))]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  2
                                )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25f48535", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f48535","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivityLog.vue
// module id = null
// module chunks = 